import React, { useState } from 'react'
import { Wrap } from 'src/components/Investment/Matured/maturedStyle'
import TabComponent from '../Global/Tabs/Tab'
import { All } from './Components/All'
import { Completed } from './Components/Completed'
import { Ongoing } from './Components/Ongoing'

const tabs = [
  {
    name: 'All',
    key: 'all',
    component: <All />,
  },
  {
    name: 'Ongoing',
    key: 'ongoing',
    component: <Ongoing />,
  },
  {
    name: 'Completed',
    key: 'completed',
    component: <Completed />,
  },
]

const TargetToggle = () => {
  const [activeTab, setActiveTab] = useState(tabs[0].key)

  return (
    <Wrap>
      <TabComponent
        tabs={tabs}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      />

      <div className={'content active-content'}>
        {tabs.map((tab) => {
          return tab.key === activeTab ? tab.component : null
        })}
      </div>
    </Wrap>
  )
}

export { TargetToggle }
